import * as React from "react";
import { useRef } from "react";
import lowerCase from "lodash/lowerCase";
import { CountBadge, Pluralize, Tooltip } from "components/common";
import useEntityCollectionStatus from "collections/hooks/useEntityCollectionStatus";
import { createGRN } from "logic/permissions/GRN";
const EntityCollectionTableCell = ({ entityId, entityType }) => {
  const entityGRN = createGRN(entityType, entityId);
  const { data, isFetching, isError } = useEntityCollectionStatus(entityGRN, entityId);
  const count = (data == null ? void 0 : data.length) || 0;
  const isDisabled = count === 0;
  const buttonRef = useRef();
  if (isFetching || isError) {
    return null;
  }
  const label = /* @__PURE__ */ React.createElement("span", null, "This ", lowerCase(entityType), " is in ", count, " ", /* @__PURE__ */ React.createElement(Pluralize, { value: count, plural: "collections", singular: "collection" }), ".");
  return /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(Tooltip, { withArrow: true, position: "right", label, disabled: isDisabled }, /* @__PURE__ */ React.createElement(CountBadge, { ref: buttonRef, count })));
};
export default EntityCollectionTableCell;
